import React from 'react';
import styled from 'styled-components';

import Courses from './Courses';

const WidgetList = styled.ul`
    @media (max-width: 767px) {
        width:100%;
    }
`

export default props => {
    const { page } = props;
    const { widgets } = props.data;

    const pageBackground = page && page.acf && page.acf.page_background ? page.acf.page_background : 'white';

    if (!widgets) {
        return null;
    }

    return (
        <WidgetList>
            {widgets.map((widget, i) => {
                if (widget.acf_fc_layout === 'products') return <Courses key={i} data={widget.items} pageBackground={pageBackground} title={widget.widget_title} />
                return null;
            })}
        </WidgetList>
    );
}



// WEBPACK FOOTER //
// ./src/partials/modules/Widgets/index.js